import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const.js';

export default {
    computed: {
        ...mapGetters({
            gripSimpleMap: 'getGripSimpleMap',
            selectedMarker: 'getSelectedMarker',
            curOpenWin: 'getCurOpenWin',
        }),
    },
    created() {
        this.$eventBus.$on('simple-map-popup-div-close',  () => {
            this.closeWin();
        });
    },
    methods: {
        openWin(content, leftOffset, topOffset, popupAreaId = '#layer-popup-div') {
            let left = window.event.x;
            let top = window.event.y;
            if (this.selectedMarker) {
                left = this.selectedMarker.eventX;
            }
            if (this.selectedMarker) {
                top = this.selectedMarker.eventY;
            }

            this.openWinAt(content, leftOffset, topOffset, left, top, popupAreaId);
        },

        openWinAt(content, leftOffset, topOffset, left, top, popupAreaId = '#layer-popup-div') {
            if (typeof this.curOpenWin !== 'undefined') {
                this.curOpenWin.hide();
            }

            if (popupAreaId.charAt(0) !== '#') {
                popupAreaId = '#' + popupAreaId;
            }

            let $layerPopupDiv = $('#layer-popup-div');

            // 창크기 초기화
            $layerPopupDiv.css({
                position: 'absolute',
                width: '',
                height: '',
            });

            $layerPopupDiv.html(content);

            let width = $layerPopupDiv.width();
            let height = $layerPopupDiv.height();

            if (typeof leftOffset === 'undefined') {
                leftOffset = 0.08;
            }

            if (typeof topOffset === 'undefined') {
                topOffset = 1.07;
            }

            left = left - width * leftOffset;
            top = top - height * topOffset;

            // 모바일 simplemap 팝업 변경
            if($_WC.responsiveScale < 3){
                left = (window.innerWidth - width) / 2;
                top = (window.innerHeight - height) / 2
            }

            $layerPopupDiv.css({
                position: 'absolute',
                left: left,
                top: top,
                width: width,
                height: height,
            });

            $(popupAreaId + ' a.self-close-btn').on('click', () => {
                this.closeWin(popupAreaId);
            });

            $layerPopupDiv.show();

            this.$store.dispatch('SET_CUR_OPEN_WIN', $layerPopupDiv);
        },

        loadedInfoHandler(content) {
            let winHeight = window.innerHeight;
            let eventY = window.event.y;
            if (this.selectedMarker) {
                eventY = this.selectedMarker.eventY;
            }

            if (eventY >= winHeight / 2) {
                this.openWin(content, 0, 1);
            } else {
                this.openWin(content, 0, 0);
            }
        },

        closeWin(popupAreaId = '#layer-popup-div') {
            if (popupAreaId.charAt(0) !== '#') {
                popupAreaId = '#' + popupAreaId;
            }

            let $layerPopupDiv = $('#layer-popup-div');
            $layerPopupDiv.hide();
            this.$store.dispatch('SET_CUR_OPEN_WIN', undefined);
        },
    },
};
